export default __webpack_public_path__ + "static/media/beaver.c0f24cab.jpg";